import React from "react";

const ContactPage = () => (
  <div className="p-60">
    <h1 className="text-2xl font-bold mb-4">Contact Us</h1>
    <p>Email: support@trushtiias.com</p>
    <p>Phone: +91 9662211365</p>
    <p>Address: Educational Institute Campus, India</p>
  </div>
);

export default ContactPage;
